<template>
    <el-dialog class="dialog" :visible="dialogs.workActions" customClass="dialog_main" :append-to-body="true" :close-on-click-modal="false" @close="closeDialog()">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner">
                <h3 class="dialog__title">Трудовые действия</h3>
            </div>
        </div>

        <div slot="default" class="dialog__inner">
            <div class="dialog__content">
                <form action="#" class="search-form" @submit.prevent="search">
                    <div class="search-form__inner">
                        <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': input && input.length !== 0 }" placeholder="Поиск" v-model.trim="input">

                        <button v-if="input && input.length !== 0" class="search-form__reset" @click="input = ''">
                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                        </button>

                        <button type="submit" class="search-form__submit">
                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                        </button>
                    </div>
                </form>

                <transition name="fade">
                    <div class="dialog__section" v-if="createEntity">
                        <h3>Заполните новое ТД</h3>

                        <form class="entity-form" @submit.prevent="createItem">
                            <div class="entity-form__inner">
                                <div class="entity-form__item">
                                    <el-checkbox v-model="checkedEntity" />
                                </div>

                                <div class="entity-form__item entity-form__item_name">
                                    <validate-input v-model="newWorkActionsName" v-bind:error="newWorkActionsNameError" v-on:update:error="newWorkActionsNameError = $event" type="text" name="name" placeholder="Название" :validateOptions="['empty']" />
                                </div>

                                <div class="entity-form__item">
                                    <button type="submit" class="btn btn_action" :disabled="!newWorkActionsName">Создать</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </transition>

                <h3 v-if="start" class="dialog__title mt-32 mb-32">Введите в поисковую строку или создайте новое ТД, чтобы выбрать ТД для добавления</h3>

                <div v-show="!start">
                    <el-table
                        cell-class-name="table__cell"
                        class="table table_second"
                        header-cell-class-name="table__title"
                        :max-height="createEntity ? 250 : 300"
                        ref="table"
                        row-key="id"
                        :data="filteredData"
                        :default-sort="{ prop: 'code', order: 'ascending' }"
                        @sort-change="sortChange"
                    >
                    <el-table-column
                                width="24"
                        >
                            <template slot-scope="scope">
                                <div class="table_flex">
                                    <el-checkbox @change="handleSelectionChange([scope.row])"/>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="Название"
                            prop="name"
                            sortable
                            :min-width="90"
                            :sort-orders="['ascending', 'descending']"
                        >
                        </el-table-column>
                    </el-table>

                    <h3 class="dialog__title mt-32 mb-16">Выбранные сущности</h3>

                    <el-table
                        cell-class-name="table__cell"
                        class="table table_second"
                        header-cell-class-name="table__title"
                        :max-height="createEntity ? 250 : 300"
                        row-key="id"
                        :show-header="false"
                        :data="selection"
                        :default-sort="{ prop: 'code', order: 'ascending' }"
                    >
                        <el-table-column
                            width="24"
                        >
                            <template slot-scope="scope">
                                <div class="table_flex">
                                    <el-checkbox checked @change="deleteSelectionChange([scope.row])"/>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="Название"
                            prop="name"
                            sortable
                            :min-width="90"
                            :sort-orders="['ascending', 'descending']"
                        >
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <footer slot="footer" class="dialog__footer mt-24">
                <div class="dialog__footer-inner">
                    <div class="dialog__footer-item">
                        <button type="button" class="btn" @click="closeDialog">Отменить</button>
                    </div>
                    <div class="dialog__footer-item">
                        <button type="submit" class="btn btn_action-second" :disabled="createEntity" @click="createEntity = true">
                            Создать новое ТД

                            <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon"><icon-action /></icon-base>
                        </button>
                        <button type="submit" class="btn btn_action" :disabled="selection.length === 0" @click="submitSelected">Добавить выбранные ТД</button>
                    </div>
                </div>
            </footer>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

import dialog from '@/mixins/dialog';
import ValidateInput from '@/components/ValidateInput'

import { mergeArrsByKey } from '@/helpers';

export default {
    mixins: [ dialog ],
    components: {
        ValidateInput
    },
    props: {
        workFunctionId: {
            required: true,
            type: Number
        },
        standart: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            checkedEntity: true,
            newWorkActionsName: '',
            newWorkActionsNameError: false,
            start: true
        }
    },
    methods: {
        ...mapActions('editor', [
            'LOAD_WORK_FUNCTION_ITEMS',
            'LOAD_WORK_FUNCTIONS_BY_STANDARD',
            'GET_WORK_ACTIONS_BY_QUALIFICATION',
            'CREATE_WORK_ACTION',
            'QUERY_WORK_ACTIONS',
            'UPDATE_WORK_FUNCTION_ITEMS',
            'UPDATE_WORK_FUNCTION_ITEMS_FOR_STANDARD'
        ]),
        ...mapMutations('editor', ['GROUP_QUALIFICATIONS', 'SET_QUALIFICATIONS']),

        closeDialog() {
            this.newWorkActionsName = ''
            this.newWorkActionsNameError = false
            this.createEntity = false
            this.start = true

            this.selection = []

            this.elDialogs.workActions = false;
        },
        createItem(e) {
            // Собираем новые значения и отправляем
            const formData = new FormData(e.target);

            const params = {
                work_function_id: this.workFunctionId
            };

            for (const pair of formData.entries()) {
                params[pair[0]] = pair[1];
            }

            this.CREATE_WORK_ACTION(params).then((workAction) => {
                e.target.reset();

                if (this.checkedEntity) {
                    this.selection.push(workAction);
                }
            });
            this.start = false
        },
        handleSelectionChange(val) {
            this.selection = [...val, ...this.selection];
        },
        deleteSelectionChange(val) {
            this.selection = this.selection.filter(select => !val.find(item => item.id === select.id))
        },
        async search() {
            await this.QUERY_WORK_ACTIONS(this.input);

            this.data = [...this.workActions];
            this.start = false
        },
        sortChange(v) {
            if (v.column.order === 'ascending') {
                this.data.sort(this.sortListAsc(v.column.property));
            } else if (v.column.order === 'descending') {
                this.data.sort(this.sortListDesc(v.column.property));
            }
        },
        async submitSelected() {
            const actionsIds = mergeArrsByKey(this.selection, this.workFunctionItems.actions, 'id').map((item) => item.id);
            const knowledgeIds = this.workFunctionItems.knowledge.map((item) => item.id);
            const skillsIds = this.workFunctionItems.skills.map((item) => item.id);

            if (this.standart) {
              await this.UPDATE_WORK_FUNCTION_ITEMS_FOR_STANDARD({
                actions: actionsIds,
                knowledge: knowledgeIds,
                skills: skillsIds,
                workFunctionId: this.workFunctionId
              })
            } else {
              await this.UPDATE_WORK_FUNCTION_ITEMS({
                  actions: actionsIds,
                  knowledge: knowledgeIds,
                  skills: skillsIds,
                  workFunctionId: this.workFunctionId
              });
            }

            if (this.standart) {
                await this.LOAD_WORK_FUNCTIONS_BY_STANDARD(this.standard.id)
            } else {
                await this.GET_WORK_ACTIONS_BY_QUALIFICATION(this.qualification.id)
    
                const tempQualifications = JSON.parse(JSON.stringify(this.qualifications))
                await this.SET_QUALIFICATIONS(tempQualifications.map(qualification => qualification.id === this.qualification.id ? Object.assign(qualification, { 'work_actions': this.workActions.length }) : qualification))
                this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);
            }

            this.closeDialog();
        }
    },
    computed: {
        ...mapState('editor', ['workActions', 'workFunctionItems', 'qualification', 'qualifications', 'groupItemsBy', 'standard']),

        filteredData() {
            return this.data.filter(el => !this.workFunctionItems.actions.find(workFunctionItem => workFunctionItem.id === el.id))
                .filter(el => !this.selection.find(select => select.id === el.id))
        }
    }
}
</script>
